import { render, staticRenderFns } from "./newListRangeOfficers.vue?vue&type=template&id=024b3314"
import script from "./newListRangeOfficers.vue?vue&type=script&lang=js"
export * from "./newListRangeOfficers.vue?vue&type=script&lang=js"
import style0 from "./newListRangeOfficers.vue?vue&type=style&index=0&id=024b3314&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports